import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderNumber: {
    description: 'shipmentDetails.content.orderNumber',
    defaultMessage: 'Order Number',
    id: '+KeFQI',
  },
  shipByDate: {
    description: 'shipmentDetails.content.shipByDate',
    defaultMessage: 'Ship By',
    id: 'qS9kDj',
  },
  batchNumber: {
    description: 'shipmentDetails.content.batchNumber',
    defaultMessage: 'Batch #',
    id: 'gw9fs9',
  },
  serviceRequested: {
    description: 'shipmentDetails.content.serviceRequested',
    defaultMessage: 'Service Requested',
    id: 'iujkDe',
  },
  shipmentHeader: {
    description: 'shipments details header',
    defaultMessage: 'Shipment',
    id: '7LncNn',
  },
});
